<template>
  <a class="twitter-timeline"
     data-chrome="nofooter transparent"
     data-height="700"
     data-width="500"
     :href="link"></a>
</template>

<script>
const TWITTER_SCRIPT = 'https://platform.twitter.com/widgets.js'

export default {
  props: {
    link: String
  },

  methods: {
    loadTwitterScript () {
      let script = document.getElementById('TWITTER_SCRIPT')
      if (!script) {
        let twitterScript = document.createElement('script')
        twitterScript.setAttribute('src', TWITTER_SCRIPT)
        twitterScript.setAttribute('id', 'TWITTER_SCRIPT')
        twitterScript.setAttribute('charset', 'utf-8')
        document.head.appendChild(twitterScript)
      } else {
        setTimeout(() => {
          // eslint-disable-next-line no-undef
          twttr.widgets.load()
        }, 500)
      }
    }
  },

  created () {
    this.loadTwitterScript()
  }
}
</script>
